import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { useConfirm } from '@/components/ui/confirm-dialog';
import { UserX } from 'lucide-react';
import type { GuildBanResponse } from '@/lib/api';

interface GuildBanListProps {
  bans: GuildBanResponse[];
  loading: boolean;
  onUnban: (banId: string) => Promise<void>;
}

export function GuildBanList({ bans, loading, onUnban }: GuildBanListProps) {
  const confirm = useConfirm();
  if (loading) {
    return <p className="text-sm text-muted-foreground">Loading bans...</p>;
  }

  if (bans.length === 0) {
    return <p className="text-sm text-muted-foreground">No banned users.</p>;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>User</TableHead>
          <TableHead>Reason</TableHead>
          <TableHead>Banned</TableHead>
          <TableHead className="w-[80px]" />
        </TableRow>
      </TableHeader>
      <TableBody>
        {bans.map((ban) => (
          <TableRow key={ban.banId}>
            <TableCell className="font-mono text-sm">{ban.username || 'Unknown'}</TableCell>
            <TableCell className="text-sm text-muted-foreground">{ban.reason || '-'}</TableCell>
            <TableCell className="text-sm text-muted-foreground">
              {new Date(ban.createdAt).toLocaleDateString()}
            </TableCell>
            <TableCell>
              <Button
                variant="ghost"
                size="sm"
                onClick={async () => {
                  if (
                    await confirm({
                      title: `Unban ${ban.username || 'Unknown'}?`,
                      description: 'They will be able to join the guild again.',
                      confirmLabel: 'Unban',
                    })
                  ) {
                    onUnban(ban.banId);
                  }
                }}
                aria-label={`Unban ${ban.username || 'Unknown'}`}
              >
                <UserX className="h-4 w-4 mr-1" />
                Unban
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
